var $888756784d832bd7$exports = {};
$888756784d832bd7$exports = {
    "close": `Fermer`,
    "notifications": `Notifications`
};


export {$888756784d832bd7$exports as default};
//# sourceMappingURL=fr-FR.mjs.map
